import { isFirefox as m } from "./index725.js";
import { isNumber as h } from "./index565.js";
let e;
const x = {
  height: "0",
  visibility: "hidden",
  overflow: m() ? "" : "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, f = [
  "letter-spacing",
  "line-height",
  "padding-top",
  "padding-bottom",
  "font-family",
  "font-weight",
  "font-size",
  "text-rendering",
  "text-transform",
  "width",
  "text-indent",
  "padding-left",
  "padding-right",
  "border-width",
  "box-sizing",
  "word-break"
], v = (i) => {
  const t = Number.parseFloat(i);
  return Number.isNaN(t) ? i : t;
};
function y(i) {
  const t = window.getComputedStyle(i), l = t.getPropertyValue("box-sizing"), a = Number.parseFloat(t.getPropertyValue("padding-bottom")) + Number.parseFloat(t.getPropertyValue("padding-top")), p = Number.parseFloat(t.getPropertyValue("border-bottom-width")) + Number.parseFloat(t.getPropertyValue("border-top-width"));
  return { contextStyle: f.map((n) => [
    n,
    t.getPropertyValue(n)
  ]), paddingSize: a, borderSize: p, boxSizing: l };
}
function z(i, t = 1, l) {
  var a, p;
  e || (e = document.createElement("textarea"), ((a = i.parentNode) != null ? a : document.body).appendChild(e));
  const { paddingSize: d, borderSize: n, boxSizing: s, contextStyle: u } = y(i);
  u.forEach(
    ([o, b]) => e?.style.setProperty(o, b)
  ), Object.entries(x).forEach(
    ([o, b]) => e?.style.setProperty(o, b, "important")
  ), e.value = i.value || i.placeholder || "";
  let r = e.scrollHeight;
  const g = {};
  s === "border-box" ? r = r + n : s === "content-box" && (r = r - d), e.value = "";
  const c = e.scrollHeight - d;
  if (h(t)) {
    let o = c * t;
    s === "border-box" && (o = o + d + n), r = Math.max(o, r), g.minHeight = `${o}px`;
  }
  if (h(l)) {
    let o = c * l;
    s === "border-box" && (o = o + d + n), r = Math.min(o, r);
  }
  return g.height = `${r}px`, (p = e.parentNode) == null || p.removeChild(e), e = void 0, g;
}
export {
  z as calcTextareaHeight,
  v as looseToNumber
};
